import { observer } from 'mobx-react-lite'
import { Button, DropdownContent, Typography } from 'shared/ui'
import { makeTextFieldAutoFocus, TextField } from 'shared/ui/TextField'
import { type Phone } from 'entities/Phone/model/Phone'
import { NumbersDropdownContentItems } from 'widgets/SearchDropdown/ui/DropdownContent/NumbersDropdownContent/NumbersDropdownContentItems'
import { type SearchDropdownNumbersStore } from 'widgets/SearchDropdown/store/searchDropdownNumbersStore'
import styles from './styles.module.scss'

type INumbersDropdownContentProps = {
  store: SearchDropdownNumbersStore
  onChange?: (item: Phone) => void
  width?: number
}

export const NumbersDropdownContent = observer(
  ({ store, onChange, width }: INumbersDropdownContentProps) => {
    const { init, search, maxLimit } = store

    const handleReset = () => {
      store.resetType()
      init()
    }

    return (
      <DropdownContent noPadding className={styles.wrap} width={width}>
        <div className={styles.searchWrap}>
          <TextField
            className={styles.search}
            variant='integrated'
            InputProps={{
              placeholder: 'Search number',
            }}
            onChange={store.handleSearch}
            value={search}
            mainActions={[makeTextFieldAutoFocus({ withFocus: !search })]}
          />
        </div>
        {maxLimit && (
          <Typography
            variant='body-sm-medium'
            color='var(--content-primary-tertiary)'
            ariaLabel='NumbersDropdownLimit'
            className={styles.limitInfo}
          >
            Select numbers (up to {maxLimit})
          </Typography>
        )}

        <NumbersDropdownContentItems store={store} onChange={onChange} />

        {store.hasSelectedItems && (
          <div className={styles.clear}>
            <Button typeBtn={'text'} text={'Clear'} onClick={handleReset} />
          </div>
        )}
      </DropdownContent>
    )
  }
)
